module.exports = __webpack_public_path__ + "static/media/en.90386a52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/en.svg
// module id = 218
// module chunks = 0